import type { TypeElements } from '../../types/element';

// ----------------------------------------------------------------------------

function appendChildren(parent: Node, elements: TypeElements): void {
    for (const element of elements) {
        parent.appendChild(element);
    }
}

// ----------------------------------------------------------------------------

export default appendChildren;
